<h2 mat-dialog-title>Vedi pagamento effettuato</h2>

<mat-dialog-content>
  <p>Qui puoi controllare il pagamento effettuato.</p>

  <p>Stato pagamento: <strong>{{ getActiveValueDisplay(data.payment.status) }}</strong></p>

  <p>Il pagamento è stato effettuato con {{data.payment.method}} in data {{data.payment.date | date : "dd/MM/yyyy" }}, per un importo di € {{data.payment.amount}}. </p>

  <!-- <form [formGroup]="paymentForm">
    <div class="d-flex justify-content-between align-items-center me-0 mb-2">
      <span>Rinnovo automatico</span>
      <span>
        <mat-form-field
          formControlName="external_link"
          color="primary"
          class="mt-2"
          matTooltip="Vedi link."
          [matTooltipShowDelay]="showDelay.value"
          [matTooltipHideDelay]="hideDelay.value"
        >
        </mat-form-field>
      </span>
    </div>
  </form> -->

  <div *ngIf="isLoading" class="text-center mt-3">
    <mat-spinner diameter="30"></mat-spinner>
    <p class="mt-2">Aggiornamento in corso...</p>
  </div>

  <mat-divider></mat-divider>

  <p class="mt-3">La ricevuta è disponibile al seguente link:</p>

  <!-- .izy-fields e' il contenitore che veste i campi con la grammatica BEIZY
       (contorno nero 2px, raggio 16px): lo stesso di tutti gli altri form
       dell'app. Definito in styles.scss. -->
  <div class="izy-fields">
    <mat-form-field appearance="outline" class="w-100">
      <mat-label>Link ricevuta</mat-label>
      <textarea
        matInput
        [value]="external_link"
        readonly
        rows="2"
        #linkInput>
      </textarea>
      <button
        mat-icon-button
        matSuffix
        (click)="copyToClipboard()"
        [attr.aria-label]="'Copia link'">
        <mat-icon>content_copy</mat-icon>
      </button>
    </mat-form-field>
  </div>

  <!-- Azione secondaria dentro il contenuto: pillola bianca bordata nera 2px,
       come i pulsanti secondari del resto dell'app. -->
  <button
    mat-stroked-button
    (click)="openPaymentAttachment(data.payment.attached_receipt)"
    class="mt-1 mb-3 w-100 izy-button-ghost custom-button-border">
    <mat-icon>attach_file</mat-icon>
    Apri qui il PDF del pagamento
  </button>

</mat-dialog-content>
<mat-dialog-actions align="end">
  <!-- Sulla fascia panna: pillola bianca per l'uscita neutra, petrol pieno per
       l'azione che chiude il dialog. -->
  <button
    mat-stroked-button
    mat-dialog-close
    [disabled]="isLoading"
    class="izy-button-ghost custom-button-border">
    Indietro
  </button>
  <button
    mat-raised-button
    matButton="filled"
    (click)="confirm()"
    [disabled]="isLoading || paymentForm.invalid"
    class="ms-2 izy-button-primary custom-button-border">
    <mat-icon>check</mat-icon>
    Ok
  </button>
</mat-dialog-actions>
